// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCreateSubmission } from '@hooks/mutations/ledger/useSubmission';
import { TransferPreapproval } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/TransferPreapproval';
import { ERR_CREATE_PREAPPROVAL_SVC, SUC_CREATE_PREAPPROVAL_SVC } from '../../../../utils/strings';

export const useCreateTransferPreapproval = () => {
  const { submit } = useCreateSubmission(
    TransferPreapproval,
    SUC_CREATE_PREAPPROVAL_SVC,
    ERR_CREATE_PREAPPROVAL_SVC,
  );
  return submit;
};
